import Avatar from "vue-avatar";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vue from "vue";
import VueFeather from "vue-feather";
import VueJsDialog from "vuejs-dialog";
import VueEllipseProgress from "vue-ellipse-progress";
import moment from "moment-timezone";
import ShareIt from "vue-share-it";
import ImageUploader from "vue-image-upload-resize";
import Vue2Editor from "vue2-editor";
import * as XLSX from "xlsx";
import VueNativeNotification from "vue-native-notification";
import Notifications from "vue-notification";
import Toast from "vue-toastification";
import emitter from "tiny-emitter/instance";

import App from "./App.vue";
import { createProvider } from "./plugins/vue-apollo";
import i18n from "./plugins/i18n";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import {
  supportedLanguages,
  wait,
  hasContents,
  getMediaUrl,
  getMediaUrls,
  getImage,
  getImages,
  getVideo,
  getVideos,
  getAudio,
  getAudios,
  capitalizeFirstLetter,
  getLocalisedValue,
  getCountryPrice,
  downloadFile,
  printHtmlAsPdf,
  downloadHtmlAsPdf,
  downloadHtmlAsImage,
  filterEmptyLocalisedValues,
  filterEmptyMediaUrls,
  getInteger,
  getFloat,
  numberInputEventFilter,
  deepCloneObject,
  textAbstract,
  noPaginationInput,
  defaultPageInput,
  defaultPagination,
} from "./app/core-module/util/coreHelper";
import {
  getTrainingModuleContentsCountText,
  getTrainingModuleContentTypeIcon,
  getTrainingModuleContentTitle,
  getTrainingProgressPercentage,
  validateTraining,
  sortTrainingModulesInTraining,
  filterTrainingModulesInTrainingRegistration,
  generateCertificateExpiryDate,
} from "@/app/course-module/helpers/courseHelper";
import {
  readFromLocalStorage,
  saveToLocalStorage,
  removeFromLocalStorage,
} from "@/app/core-module/util/localStorageHandler";
import { formatPrice } from "@/app/core-module/util/currencyHelper";
import { customLocalisedAutoCompleteFilter } from "@/app/core-module/util/languageHelper";
import {
  validateQuizContent,
  getRandomSubArray,
} from "@/app/quiz-module/helpers/quizHelper";

Vue.config.productionTip = false;

Vue.component("Avatar", Avatar);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("VueFeather", VueFeather);

Vue.use(VueJsDialog, VueEllipseProgress, {
  html: true,
  loader: true,
  okText: "Yes",
  cancelText: "No",
});
Vue.use(ShareIt);
Vue.use(ImageUploader);
Vue.use(Vue2Editor);
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});
Vue.use(Notifications);
Vue.use(Toast, {
  timeout: 5000,
  bodyClassName: ["text-sm"],
  toastClassName: ["px-4 py-4"],
  position: "bottom-center",
});

Vue.mixin({
  methods: {
    moment,
    customLocalisedAutoCompleteFilter,
    formatPrice,
    readFromLocalStorage,
    saveToLocalStorage,
    removeFromLocalStorage,
    supportedLanguages,
    wait,
    hasContents,
    getMediaUrl,
    getMediaUrls,
    getImage,
    getImages,
    getVideo,
    getVideos,
    getAudio,
    getAudios,
    capitalizeFirstLetter,
    getLocalisedValue,
    getCountryPrice,
    downloadFile,
    printHtmlAsPdf,
    downloadHtmlAsPdf,
    downloadHtmlAsImage,
    filterEmptyLocalisedValues,
    filterEmptyMediaUrls,
    getInteger,
    getFloat,
    numberInputEventFilter,
    deepCloneObject,
    textAbstract,
    noPaginationInput,
    defaultPageInput,
    defaultPagination,
    getTrainingModuleContentsCountText,
    getTrainingModuleContentTypeIcon,
    getTrainingModuleContentTitle,
    getTrainingProgressPercentage,
    validateTraining,
    sortTrainingModulesInTraining,
    filterTrainingModulesInTrainingRegistration,
    generateCertificateExpiryDate,
    validateQuizContent,
    getRandomSubArray,
  },
});

Vue.prototype.$moment = moment;
Vue.prototype.$xlsx = XLSX;
Vue.prototype.$emitter = emitter;

new Vue({
  render: h => h(App),
  apolloProvider: createProvider(),
  i18n,
  router,
  store,
  vuetify,
}).$mount("#app");
